import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-unauth-navbar',
  templateUrl: './unauth-navbar.component.html',
  styleUrls: ['./unauth-navbar.component.scss']
})
export class UnauthNavbarComponent implements OnInit {

  constructor(public router: Router) { }
  // hamburger;
  // navLinks;
  // links;
  isLandingPage: boolean

  @ViewChild('hamburger') hamburger: ElementRef;
  @ViewChild('navLinksWrapper') navLinksWrapper: ElementRef;
  @ViewChildren('navLink') links: QueryList<ElementRef>;

  ngOnInit(): void {
    this.isLandingPage = this.router.url == '/home'? true : false
    // this.hamburger = document.querySelector(".hamburger");
    // this.navLinks = document.querySelector(".nav-links-wrapper");
    // this.links = document.querySelectorAll(".nav-links li");
    setTimeout(() => {
      // this.initNavBar();
    }, 500);
  }

  // initNavBar = () => {
  //   this.hamburger.addEventListener("click", () => {
  //     //Animate Links
  //     this.navLinks.classList.toggle("open");
  //     this.links.forEach((link) => {
  //       link.classList.toggle("fade");
  //     });
  //     //Hamburger Animation
  //     this.hamburger.classList.toggle("toggle");
  //   });
  // };

  toggleHamburger =  () => {
    // //Animate Links
    // this.navLinks.classList.toggle("open");
    // console.log(this.navLinks)
    // this.links.forEach((link) => {
    //   link.classList.toggle("fade");
    // });
    // //Hamburger Animation
    // this.hamburger.classList.toggle("toggle");
    //Animate Links
    this.navLinksWrapper.nativeElement.classList.toggle("open");
    this.links.forEach((link) => {
      link.nativeElement.classList.toggle("fade");
    });
    //Hamburger Animation
    this.hamburger.nativeElement.classList.toggle("toggle");
  }

  showNavbarBackground = false;
  prevScrollPos = window?.pageYOffset;

  @HostListener("window:scroll", [])
  onWindowScroll() {
    const currentScrollPos = window?.pageYOffset;
    this.showNavbarBackground = true;
    this.prevScrollPos = currentScrollPos;
    if (window.pageYOffset === 0) {
      this.showNavbarBackground = false;
    }
  }

  checkhamburger = () => {
    if (window.innerWidth <= 800) this.hamburger.nativeElement.click();
    else return;
  };

  openAccessModal: boolean = false;
  openGuestAccessModal() {
    this.openAccessModal = !this.openAccessModal;
  }
}
